






















import Component from "vue-class-component";
import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";

import CoreAPI from "@/utils/core-api";
import EventBus from "@/utils/event-bus";
import { LOGIN_SUCCESS } from "@/utils/constants";
import * as modals from "@/utils/modals";

export const STORAGE_KEY_USERNAME = "username";

@Component
export default class SignIn extends BaseRootPageComponent {
  username = this.loadUsername();
  password = "";
  error = "";

  mounted() {
    // redirect to "home" route if we're already logged in
    if (this.user) {
      this.$router.push(this.routes[0].path);
    }
  }

  private loadUsername() {
    return localStorage.getItem(STORAGE_KEY_USERNAME) || "";
  }

  private rememberUsername() {
    // Only "remember" the user for the mobile app since multiple people will be sharing the same PC
    if (this.$nativeApp.isMobile) {
      localStorage.setItem(STORAGE_KEY_USERNAME, this.username);
    }
  }

  async login() {
    try {
      const token = await CoreAPI.login(this.username, this.password, this.$nativeApp.isMobile);
      this.rememberUsername();
      EventBus.$emit(LOGIN_SUCCESS, { token: token });
    } catch (error) {
      if ((error as any).isNetworkError) {
        await modals.showLostConnectionModal(this.$bvModal);
      } else {
        this.error = "Sign in failed.";
      }
    }
  }
}
